export const isSessionExpiredError = (error) => {
  return (
    error?.response?.data?.code === "SESSION_EXPIRED"
  );
};


export const getSessionExpiredMessage = (error) => {
  if (isSessionExpiredError(error)) {
    return (
      "Your table session has ended. " +
      "Please scan the table QR code again to start a new session."
    );
  }

  return (
    error?.response?.data?.detail ||
    error?.message ||
    "Something went wrong. Please try again."
  );
};